import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS,
  AFFILIATE_PROGRAM_PROMO_CODES_ROUTE_NAME,
} from '@modules/affiliate-program-promo-codes/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import { AFFILIATE_PROGRAM_PROMO_CODES_CREATE_ROUTE_NAME } from './constants';

export class AffiliateProgramPromoCodesCreateModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_PROGRAM_PROMO_CODES_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_PROMO_CODES_CREATE_ROUTE_NAME,
      path: 'create',
      permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.CREATE,
      component: () => import('./pages/AffiliateProgramPromoCodesCreatePage/AffiliateProgramPromoCodesCreatePage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
